import React from "react";
import DonutChart from "../DonutChart";

const SpendingDonutChartWithLegend = ({
  data,
  centerLabel,
  centerValue,
  size = 200,
}) => {
  return (
    <div className="donut-with-legend-container">
      {/* 1. The Visual Chart */}
      <DonutChart
        data={data}
        centerLabel={centerLabel}
        centerValue={centerValue}
        size={size}
        strokeWidth={size <= 160 ? 18 : 28}
      />

      {/* 2. The Legend List */}
      <div
        className="donut-legend-list"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          flex: 1,
        }}
      >
        {data.map((item, index) => (
          <div
            key={index}
            className="donut-legend-item"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {/* Color Dot */}
              <div
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: item.color,
                }}
              />
              <span
                className="tiny-label"
                style={{ color: "var(--text-secondary)" }}
              >
                {item.label}
              </span>
            </div>
            {/* Value */}
            <span className="tiny-label-bold">
              ${item.value.toLocaleString()}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpendingDonutChartWithLegend;
